export default __webpack_public_path__ + "static/media/compliance_and_corporate_policy.f2bf7fac.svg";